import { cva } from 'class-variance-authority';
import clsx from 'clsx';
import React from 'react';

const quizOptionCVA = cva('si-option', {
  variants: {
    state: {
      default: 'si-cursor--pointer',
      selected: 'si-selected',
      success: 'si-success',
      error: 'si-error',
      disabledContent: 'si-disabled--content',
      disabledOption: 'si-disabled'
    }
  }
});

const QuizOption = ({ state, children, ...restProps }) => {
  return (
    <div className={clsx(quizOptionCVA({ state }))} {...restProps}>
      <span>{children}</span>
    </div>
  );
};

export default QuizOption;
